<template>
	<div class="guide-wrap">
		<div class="guide-left-wrap">
			<div class="guide-text">
				小宝积分是将您闲置的带宽加入小宝驿站，对于有贡献闲置带宽的用户就会获得积分奖励，积分可以兑换各类VIP卡或电话卡，让您快乐享受积分收益。本服务不会影响您的看视频、玩游戏、购物的上网体验。
			</div>
			<div class="guide-btn" @click="speedClick">确 定</div>
		</div>
		<div class="guide-right-wrap">
			<div class="guide-icon"></div>
			<div class="guide-icon-tips">
				20M上行带宽月均可获得20000积分收益（具体收益以实际情况为准）
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		speedClick: function () {
			this.$emit("speedClick");
		},
	},
};
</script>

<style lang="less" scoped>
.guide-wrap {
	position: relative;
	margin: 0 auto;
	padding-top: 1px;
	width: 940px;
	height: 415px;
	border: 1px solid #e4e0c9;
	background-color: #f9fafc;
	box-sizing: border-box;
	border-radius: 3px;
	overflow: hidden;
	text-align: left;

	.guide-left-wrap,
	.guide-right-wrap {
		display: inline-block;
		vertical-align: top;
		height: 100%;
	}

	.guide-left-wrap {
		width: 460px;
	}

	.guide-right-wrap {
		width: 425px;
	}

	.guide-text {
		width: 350px;
		color: #666666;
		font-size: 14px;
		text-align: left;
		text-indent: 2em;
		margin: 0 auto;
		line-height: 24px;
		margin-top: 90px;
	}
	.guide-icon {
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-position: center;
		width: 423px;
		height: 266px;
		background-image: url("../../assets/speed/speed1.svg");
		margin-top: 60px;
	}
	.guide-icon-tips {
		font-size: 12px;
		color: #999999;
		text-align: center;
		margin-top: 20px;
	}
	.guide-btn {
		width: 195px;
		height: 54px;
		line-height: 54px;
		border-radius: 27px;
		background-color: #2662e6;
		background-image: url("../../assets/speedShare/guide_btn.svg");
		background-size: 100% 100%;
		color: #ffffff;
		font-weight: bold;
		cursor: pointer;
		text-align: center;
		margin-left: 60px;
		font-size: 20px;
		font-weight: bolder;
		margin-top: 40px;
	}
	.guide-btn:hover {
		opacity: 0.9;
	}
}
</style>